<template>
  <div>
    <label
      :for="`${field.name}[0]`"
      class="block text-sm font-medium text-gray-700"
    >
      {{ field.label }}<span v-if="field.required">*</span>
    </label>
    <ul>
      <li v-for="(option, i) in currentValue" v-bind:key="i">
        <div class="flex mb-1">
          <input
            type="text"
            :id="`${field.name}[${i}]`"
            :name="`${field.name}[${i}]`"
            class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
            :required="field.required"
            v-model="currentValue[i]"
          />
          <button
            v-if="i !== 0"
            class="m-1"
            @click="
              (e) => {
                e.preventDefault();
                removeRow(i);
              }
            "
            :aria-label="$t('fields.remove_row')"
          >
            <svg
              class="h-6 w-6"
              xmlns="http://www.w3.org/2000/svg"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </li>
      <button
        type="button"
        class="btn-secondary mt-2"
        @click="
          (e) => {
            e.preventDefault();
            addRow();
          }
        "
      >
        {{ $t('fields.add_row') }}
      </button>
    </ul>
    <p v-if="field.explainer" class="text-sm text-gray-500">
      {{ field.explainer }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'TextArrayField',
  data() {
    return {
      currentValue: this.value ? this.value : [''],
    };
  },
  methods: {
    addRow() {
      this.currentValue.push('');
    },
    removeRow(i) {
      this.$delete(this.currentValue, i);
    },
  },
  watch: {
    currentValue: function (newValue) {
      this.$emit('input', {
        target: { name: this.field.name, value: newValue },
      });
    },
  },
  props: {
    field: Object,
    value: Array,
  },
};
</script>
